// selectors.ts

import { ApplicationState } from '../index';

// Base selector
export const selectPage = (state: ApplicationState) => state.page;
export const selectVariableData = (state: ApplicationState) => selectPage(state).variableData;

export const selectLocalVariableData = (state: ApplicationState) => selectPage(state).settings?.variables;
